import { render, staticRenderFns } from "./PertoDeVoce.vue?vue&type=template&id=b7b6f65e&scoped=true&"
import script from "./PertoDeVoce.vue?vue&type=script&lang=js&"
export * from "./PertoDeVoce.vue?vue&type=script&lang=js&"
import style0 from "./PertoDeVoce.vue?vue&type=style&index=0&id=b7b6f65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b6f65e",
  null
  
)

export default component.exports